module.exports = __webpack_public_path__ + "img/route-durban.4aa32de0.webp";